var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('home-banner',{attrs:{"title":"档案管理客户案例","description":"由纸质档案向电子化档案转型的必选工具。"}}),_c('customer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }